
















































import { computed, defineComponent } from "@vue/composition-api";
import Button from "@/components/Atoms/Button/index.vue";
import OccPanel from "@/components/Atoms/OccPanel/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccTag from "@/components/Atoms/OccTag/index.vue";
import { closePopover, VTooltipEvent } from "@/helpers/v-tooltip-helper";

export type FilterConfig = {
  lavel: string;
  key: string;
  value?: string | (string | number)[];
  type: "select" | "multiSelect" | "textInput" | "checkBox";
  slectedList?: string[];
};
export default defineComponent({
  name: "ListFilter",
  components: {
    Button,
    OccPanel,
    OccHeading,
    OccTag
  },
  emits: ["reset", "submit"],
  props: {
    filterCount: {
      type: Number,
      default: undefined
    },
    gaEventCategory: {
      type: String,
      default: ""
    },
    popoverWidth: {
      type: String,
      default: "616px"
    }
  },
  setup(props, { emit }) {
    const onClickReset = (event: VTooltipEvent) => {
      closePopover(event);
      emit("reset");
    };
    const onClickSubmit = (event: VTooltipEvent) => {
      closePopover(event);
      emit("submit");
    };

    const popoverStyle = computed(() => {
      return { width: props.popoverWidth };
    });

    return {
      onClickReset,
      onClickSubmit,
      popoverStyle
    };
  }
});
